// import { exportExcelCommerce } from "../component/cdevs/allFunctions";

export default {
  baseURL: process.env.VUE_APP_BASE_URL || "https://old.prod.41devs.co",
  // baseURL: 'http://localhost:8000',
  baseURLAccountant: process.env.VUE_APP_BASE_URL_ACCOUNTANT || "https://old.api.uat.41devs.co",
  login: "/api/v1/admin/login",
  allCommerce: "/api/v1/entreprise/admin",
  get_all_commerce: "/api/v1/entreprise/all-company",
  allCommerceParginate: "/api/v1/entreprise/paginate",
  commerceDetail: "/api/v1/admin/commerce/detail",
  bilanStat: "/api/v1/admin/commerce/bilan",
  allClient: "/api/v1/admin/commerce/searchData",
  allSfd: "/api/v1/sfd",
  createSfd: "/api/v1/sfd",
  createSfdAdmin: "/api/v1/admin/createAdminSfd",
  allAdmin: "/api/v1/admin",
  deleteAdmin: (id) => `/api/v1/admin/${id}`,
  createCommercialSfd: "/api/v1/admin/createCommercialSfd",
  allEnroleForCommercial: "/api/v1/sfdParticipation/commercialEnrol",
  allCoupons: "/api/v1/commercial",
  generateCoupon: "/api/v1/commercial/generate",
  createAdmin: "/api/v1/admin/createAdmin",
  allStat: "/api/v1/admin/stats/commerce",
  abonnementStat: "/api/v1/admin/stats/abonnement",
  desactiveCommercial: "/api/v1/admin/commercialActivation",
  statBySfd: "/api/v1/admin/stats/statForOneSfd",
  changePass: "/api/v1/auth/changeActualPassword",
  allDemande: "/api/v1/entreprise/dgi/allDemande",
  create_chartered_accountant: "/auth/create-chartered-accountant",
  get_all_accountant: "/auth/all-accountant",
  upload_file: "/firebase-storage/upload",
  get_all_affected: "/affectation/get-all",
  create_affectation: "/affectation/create-in-previous-api",
  accountant_stats: "/stats/expert-stats",
  create_service: "/services/create",
  get_all_service: "/services/get-all",
  get_all_service_for_extern: "/services/get-for-extern",
  update_service: "/services/update",
  get_all_service_request: "/request-service/get-all",
  update_service_request: "/request-service/update",
  get_all_request_expert: "/request-expert/get-all",
  update_request_expert: "/request-expert/update",
  get_stats_admin: "/stats-admin/global-data",
  get_expert_stats: "/stats/expert-stats",
  get_all_comptable: "/api/v1/admin/stats/for-company",
  unactive_user: "/api/v1/auth/deleteUser",
  get_stats_signup: "/api/v1/admin/stats/signup",
  confirm_delete: "/api/v1/auth/confirm-delete",
  relaunch_sms: "/api/v1/entreprise/relaunchSms",
  deleteSfd: (id) => `/api/v1/sfd/${id}`,
  updateSfd: "/api/v1/sfd",
  exportExcelCommerce: "/api/v1/entreprise/export",
  sendInvitationAccountant: "/auth/send-mail",
  exportExcelInfo: "/api/v1/entreprise/export-last-action",
  // limitate view 
  limitate_view: (id) => `/api/v1/admin/${id}`,
  desactiveAdmin: (id) => `/api/v1/admin/update-admin-inactive/${id}`,
  reactiveAdmin: (id) => `/api/v1/admin/update-admin-active/${id}`,
};
